<script>
import MainMenuStudentView from '../../../shared/views/MainMenuStudentView';
import ListStudentsNotificationsView from '../../views/lists/ListStudentsNotificationsView';

export default {
  components: {
    'main-menu-view': MainMenuStudentView,
    'list-students-notifications-view': ListStudentsNotificationsView,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<template>
  <div>
    <main-menu-view />
    <list-students-notifications-view />
  </div>
</template>
